import React from 'react';
import { Box } from '../../../../wag-react/next-components/box';
import { Flex } from '../../../../wag-react/core-components/flex';
import { Text } from '../../../../wag-react/core-components/text';
import { Image } from '../../../../wag-react/next-components/image';
import { GetStartedButton } from '../../../../components/GetStartedButton';
import howWagWorksApp from './assets/how-wag-works-app.png';
import pawsIcon from './assets/paws.svg';
import userCheckIcon from './assets/user_check.svg';
import mapPinIcon from './assets/map_pin.svg';
import calendarIcon from './assets/calendar_2.svg';
const items = [{
  id: 'pick-service',
  icon: pawsIcon,
  title: 'Pick a service',
  description: 'Whether it\'s Walks, Drop-Ins, Sittings, or Boardings, choose the service that best fits your pet\'s needs.'
}, {
  id: 'choose-caregiver',
  icon: userCheckIcon,
  title: 'Choose your Caregiver',
  description: 'Select from committed Caregivers who understand your requirements. Chat directly to ensure the perfect match!'
}, {
  id: 'follow-app',
  icon: mapPinIcon,
  title: 'Follow along in the app',
  description: 'Download the Wag! App to track walks via GPS, communicate with your Caregiver, and enjoy real-time photo and video updates.'
}, {
  id: 'rate-review',
  icon: calendarIcon,
  title: 'Rate and review',
  description: 'Share feedback to help other Pet Parents find their perfect Caregiver.'
}];
export const HowWagWorks = () => {
  return <Box backgroundColor="#F9F9F9" py={40} width="100%" data-sentry-element="Box" data-sentry-component="HowWagWorks" data-sentry-source-file="HowWagWorks.tsx">
      <Box maxWidth="1200px" mx="auto" px={0} data-sentry-element="Box" data-sentry-source-file="HowWagWorks.tsx">
        <Flex flexDirection={['column', 'column', 'row']} alignItems="center" justifyContent="center" data-sentry-element="Flex" data-sentry-source-file="HowWagWorks.tsx">
          {/* Mobile: Bottom, Desktop: Left - Image */}
          <Box order={[2, 2, 1]} width={['100%', '100%', '48%']} display="flex" justifyContent={['center', 'center', 'flex-end']} mb={[0, 0, 0]} mr={[0, 0, 0]} data-sentry-element="Box" data-sentry-source-file="HowWagWorks.tsx">
            <Image src={howWagWorksApp} alt="How Wag! works app" width={'100%'} height="auto" data-sentry-element="Image" data-sentry-source-file="HowWagWorks.tsx" />
          </Box>

          {/* Mobile: Top, Desktop: Right - Content */}
          <Box order={[1, 1, 2]} width={['100%', '100%', '52%']} maxWidth={['100%', '100%', '650px']} mb={[4, 4, 0]} ml={[0, 0, 4]} px={2} data-sentry-element="Box" data-sentry-source-file="HowWagWorks.tsx">
            <Text as="h2" color="#222" fontSize={['26px', '36px']} lineHeight={['42px', '68px']} mb={0} mt={0} style={{
            fontFamily: '"Hero New", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
            fontWeight: 700,
            letterSpacing: '0px'
          }} data-sentry-element="Text" data-sentry-source-file="HowWagWorks.tsx">
              How Wag! works
            </Text>

            <Text color="#474747" fontSize="18px" lineHeight="28px" mb="30px" mt={2} style={{
            fontFamily: '"Hero New", sans-serif',
            fontWeight: 400
          }} data-sentry-element="Text" data-sentry-source-file="HowWagWorks.tsx">
              Easily find and book trusted Pet Caregivers near you
            </Text>

            <Box py={0} data-sentry-element="Box" data-sentry-source-file="HowWagWorks.tsx">
              {items.map(item => <Flex key={item.id} alignItems="flex-start" mb={item !== items[items.length - 1] ? 3 : 0}>
                  <Box mt="0px" mr={2}>
                    <Image src={item.icon} alt={item.title} width="32px" height="32px" />
                  </Box>
                  <Box>
                    <Text fontSize="18px" lineHeight="24px" color="#222" mb={1} mt={1} style={{
                  fontFamily: '"Hero New", sans-serif',
                  fontWeight: 700
                }}>
                      {item.title}
                    </Text>
                    <Text fontSize="16px" lineHeight="24px" color="#474747" mt={1} mb={0} style={{
                  fontFamily: '"Hero New", sans-serif',
                  fontWeight: 400
                }}>
                      {item.description}
                    </Text>
                  </Box>
                </Flex>)}
            </Box>

            <Box mt={3} textAlign={['center', 'center', 'left']} data-sentry-element="Box" data-sentry-source-file="HowWagWorks.tsx">
              <GetStartedButton data-sentry-element="GetStartedButton" data-sentry-source-file="HowWagWorks.tsx" />
            </Box>
          </Box>
        </Flex>
      </Box>
    </Box>;
};